'use strict';
(() => {
  const directions = [
    {key:'marine',match:/\bsea\b|ocean|marine|海风|海洋|海边/i},
    {key:'citrus',match:/citrus|lemon|orange|bergamot|grapefruit|柑橘|柑|柠檬|橙|佛手|葡萄柚/i},
    {key:'wood',match:/forest|wood|pine|cedar|sandal|森林|木|松|杉|檀/i},
    {key:'tea',match:/\btea\b|茶/i},
    {key:'green',match:/rain|moss|leaf|green|雨|苔|叶|绿意/i},
    {key:'floral',match:/flower|floral|rose|jasmine|bloom|花|玫瑰|茉莉/i},
    {key:'warm',match:/warm|cozy|amber|vanilla|温暖|暖|琥珀|香草/i},
    {key:'spice',match:/spice|pepper|cinnamon|cardamom|辛香|胡椒|肉桂|豆蔻/i}
  ];
  const reviewPairs = {'citrus+marine':'marine_citrus_review','tea+wood':'tea_wood_review','green+wood':'green_wood_review','tea+warm':'tea_warm_review','citrus+floral':'citrus_floral_review','warm+wood':'warm_wood_review','spice+wood':'spice_wood_review','green+tea':'green_tea_review'};
  function init(root) {
    if(root.dataset.scentReady) return;
    const copyV1 = JSON.parse(root.querySelector('[data-ss-copy]').textContent);
    const copyV2 = JSON.parse(root.querySelector('[data-ss-copy-v2]').textContent);
    const copy = {en:{...copyV1.en,...copyV2.en},zh:{...copyV1.zh,...copyV2.zh}};
    const find = name => root.querySelector('[data-ss-'+name+']');
    const all = name => root.querySelectorAll('[data-ss-'+name+']');
    let language = new URLSearchParams(location.search).get('lang') === 'zh' ? 'zh' : 'en';
    let result = null;
    const text = key => copy[language][key];
    const keywords = find('keywords'), avoid = find('avoid');
    const unsafeControls = /[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f\u202a-\u202e\u2066-\u2069]/;
    function brief() {
      return {keywords:keywords.value.trim(),avoid:avoid.value.trim(),strength:root.querySelector('[data-ss-strength]:checked')?.value,base:root.querySelector('[data-ss-base]:checked')?.value,format:root.querySelector('[data-ss-format]:checked')?.value};
    }
    function valid(value) {
      return value.keywords.length > 0 && keywords.value.length <= 500 && avoid.value.length <= 200 && !unsafeControls.test(value.keywords+' '+value.avoid) && ['soft','balanced','bold'].includes(value.strength) && ['wood_base','resin_base','botanical_base'].includes(value.base) && ['powder','incense','oil'].includes(value.format);
    }
    function emit(name,value=brief()) {
      document.dispatchEvent(new CustomEvent('ss:scent-card-event',{detail:{name,format:value.format,base:value.base,strength:value.strength}}));
    }
    function notes(value) {
      const clauses=value.keywords.split(/[,，、;；\n]/);
      const negative=clauses.filter(s=>/不喜欢|不要|避免|不想|without|avoid|\bno\b/i.test(s));
      const positive=clauses.filter(s=>!negative.includes(s)).join(',');
      const exclusions=value.avoid+' '+negative.join(',');
      return directions.map(note=>({note,index:positive.search(note.match)})).filter(({note,index})=>index>=0&&!note.match.test(exclusions)).sort((a,b)=>a.index-b.index).slice(0,2).map(({note})=>note);
    }
    function setStep(step) {
      all('step').forEach(el=>el.hidden=Number(el.dataset.ssStep)!==step);
      all('progress').forEach(el=>{if(Number(el.dataset.ssProgress)===Math.min(step,3))el.setAttribute('aria-current','step');else el.removeAttribute('aria-current');});
      const heading=root.querySelector('[data-ss-step="'+step+'"] h2');
      heading.focus({preventScroll:true});
      heading.scrollIntoView({block:'start',behavior:'auto'});
    }
    function updateInput() {
      find('count').textContent=keywords.value.length+' / 500';
      find('error').textContent='';
      find('preference-error').textContent='';
      find('chips').querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(keywords.value.includes(button.textContent))));
    }
    function renderChips() {
      const container=find('chips');container.replaceChildren();
      for(const key of ['chip_forest','chip_tea','chip_sea','chip_floral','chip_evening','chip_citrus']) {
        const button=document.createElement('button');button.type='button';button.textContent=text(key);button.setAttribute('aria-pressed','false');
        button.addEventListener('click',()=>{const existing=keywords.value.trim();if(!existing.includes(button.textContent)) keywords.value=((existing?existing+', ':'')+button.textContent).slice(0,500);updateInput();});
        container.append(button);
      }
    }
    function renderResult() {
      if(!result) return;
      const selected=notes(result);
      const title=selected.length?selected.map(note=>text(note.key)).join(' × '):text('result_heading');
      const pair=selected.map(note=>note.key).sort().join('+');
      const review=!selected.length?text('unmatched_review'):selected.length===1?text(selected[0].key+'_detail'):reviewPairs[pair]?text(reviewPairs[pair]):text('generic_review').replace('{main}',text(selected[0].key)).replace('{companion}',text(selected[1].key));
      all('title').forEach(el=>el.textContent=title);
      all('review').forEach(el=>el.textContent=review);
      all('meta').forEach(el=>el.textContent=text(result.format)+' · '+text(result.base)+' · '+text(result.strength));
      all('craft').forEach(el=>el.hidden=selected.length!==2);
      all('notes').forEach(container=>{
        container.replaceChildren();
        if(!selected.length){const message=document.createElement('p');message.className='ss-scent-unmatched';message.textContent=text('unmatched');container.append(message);return;}
        for(let index=0;index<2;index++) {
          const note=selected[index];const article=document.createElement('article');article.className='ss-scent-note'+(note?'':' ss-scent-pending');
          const role=document.createElement('p');role.textContent=text(index?'companion':'leading');
          const name=document.createElement('h3');name.textContent=note?text(note.key):text('pending');
          const detail=document.createElement('p');detail.textContent=note?text(note.key+'_detail'):text('pending_detail');
          article.append(role,name,detail);container.append(article);
        }
      });
      const briefKeys={keywords:'keywords_label',strength:'intensity',base:'base_brief',format:'format_label',avoid:'avoid_label'};
      all('brief').forEach(container=>{container.replaceChildren();for(const key of Object.keys(briefKeys)){const row=document.createElement('div');row.className='ss-scent-brief-row';const dt=document.createElement('dt');dt.textContent=text(briefKeys[key]);const dd=document.createElement('dd');dd.textContent=['strength','base','format'].includes(key)?text(result[key]):result[key]||text('none');row.append(dt,dd);container.append(row);}});
      all('price').forEach(el=>el.textContent=text(result.format+'_price'));
      all('waitlist-tags').forEach(el=>el.value='prospect,scent-card,private-custom-interest,'+result.format);
    }
    function applyLanguage() {
      root.lang=language==='zh'?'zh-Hans':'en';
      all('text').forEach(el=>el.textContent=text(el.dataset.ssText));
      keywords.placeholder=text('keywords_placeholder');avoid.placeholder=text('avoid_placeholder');
      all('email').forEach(el=>el.placeholder=text('email_placeholder'));
      find('language').textContent=text('switch_label');find('language').setAttribute('aria-label',text('language_aria'));find('progress-nav').setAttribute('aria-label',text('progress_aria'));
      renderChips();updateInput();renderResult();
    }
    function create() {
      const value=brief();
      if(!valid(value)){if(!value.keywords){setStep(1);find('error').textContent=text('error');keywords.focus();}else find('preference-error').textContent=text('invalid');return;}
      result=Object.freeze({...value});renderResult();emit('scent_card_complete',result);setStep(3);
    }
    keywords.addEventListener('input',updateInput);avoid.addEventListener('input',updateInput);
    find('next').addEventListener('click',()=>{if(!keywords.value.trim()){find('error').textContent=text('error');keywords.focus();return;}if(keywords.value.length>500||unsafeControls.test(keywords.value)){find('error').textContent=text('invalid');return;}emit('scent_card_start');setStep(2);});
    find('create').addEventListener('click',create);
    all('back').forEach(button=>button.addEventListener('click',()=>setStep(Number(button.dataset.ssBack))));
    find('card').addEventListener('click',()=>{if(result){emit('scent_card_view',result);setStep(4);}});
    find('save').addEventListener('click',()=>{if(result){emit('scent_card_save',result);window.print();}});
    all('format').forEach(input=>input.addEventListener('change',()=>emit('form_interest')));
    root.querySelector('.ss-scent-waitlist')?.addEventListener('submit',()=>emit('waitlist_opt_in',result||brief()));
    find('language').addEventListener('click',()=>{language=language==='en'?'zh':'en';applyLanguage();});
    applyLanguage();find('controls').disabled=false;find('language').disabled=false;root.dataset.scentReady='true';
  }
  document.querySelectorAll('[data-ss-scent]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-ss-scent]').forEach(init));
})();
